export type AmountType = {
  value: number;
  label: string;
};

export const AMOUNTS: { [key in string]: AmountType[] } = {
  IRT: [
    { value: 500000, label: '500,000' },
    { value: 1000000, label: '1,000,000' },
    { value: 2000000, label: '2,000,000' },
    { value: 3000000, label: '3,000,000' },
    { value: 4000000, label: '4,000,000' },
    { value: 5000000, label: '5,000,000' },
    { value: 10000000, label: '10,000,000' },
  ],
  TRY: [
    { value: 200, label: '200' },
    { value: 500, label: '500' },
    { value: 1000, label: '1,000' },
    { value: 5000, label: '5,000' },
    { value: 10000, label: '10,000' },
    { value: 50000, label: '50,000' },
    { value: 100000, label: '100,000' },
  ],
};
